import { useMutation } from '@tanstack/react-query';
import { deleteProcessedTimesheetEntry } from '../Services/ProcessedTimesheetService';

const useDeleteProcessedTimeSheetEntry = (options = {}) =>
    useMutation(deleteProcessedTimesheetEntry, options);

export default useDeleteProcessedTimeSheetEntry;
